function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSaveRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 27H9v-6a2 2 0 012-2h10a2 2 0 012 2v6zM10 5h7v4h2V5h3v5a2 2 0 01-2 2h-8a2 2 0 01-2-2V5zm13-2H5a2 2 0 00-2 2v22a2 2 0 002 2h22a2 2 0 002-2V9l-6-6z",
    fill: props.color
  }));
}

export default SvgIconSaveRexFilled;